import { useEffect } from 'react';
import { PrivatePage } from '../../../components/private-page';
import ZonePendingGrid from '../../../features/zone-pending-grid';
import { ctGameDefault, ctGameTitle } from '../../../constants/text';

export default function ZoneApproval() {
  useEffect(() => {
    document.title = ctGameTitle + ' - Zones Pending Approval';

    return () => {
      // return default value when component unmounts
      document.title = ctGameDefault;
    };
  }, []);

  return (
    <PrivatePage
      className={'page-base--full'}
      breadcrumb={[
        { label: 'Dashboard', href: 'dashboard' },
        { label: 'Administration', href: '../administration' },
        {
          label: 'Zone Map Pending Approval',
          href: 'administration/zones/pending'
        }
      ]}
      pageTitle={'Administration'}>
      <ZonePendingGrid />
    </PrivatePage>
  );
}
